const formatCurrency = (amount, currency) => {
  const locale = currency === 'INR' ? 'en-IN' : 'en-US';
  const roundedAmount = Math.round(amount || 0);
  return new Intl.NumberFormat(locale, { 
    style: 'currency', 
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(roundedAmount);
};

const generateCustomerKey = (c) => {
    const name = c.name ? c.name.trim().toUpperCase().replace(/\s+/g, ' ') : '';
    const gst = c.gstin ? c.gstin.trim().toUpperCase() : '';
    const state = c.state ? c.state.trim().toUpperCase() : '';
    const addressStart = c.address ? c.address.trim().substring(0, 15).toUpperCase().replace(/\s+/g, '') : '';
    return `${name}|${gst}|${state}|${addressStart}`;
};

export { formatCurrency, generateCustomerKey };
